<template>
  <div class="web-card-info">
    <!-- 页面头部 -->
    <div class="page-header">
      <h1>{{ $t('app.website.cardSearch.title') }}</h1>
      <!-- 搜索框 -->
      <div class="search-container">
        <el-input v-model="searchIccid" :placeholder="$t('app.website.cardSearch.iccidPlaceholder')" clearable
                  style="width: 300px"
                  @keyup.enter="handleSearch"></el-input>
        <el-button type="primary" @click="handleSearch" style="margin-left: 10px">
          {{ $t('app.common.search') }}
        </el-button>
        <el-button type="info" @click="handleBack" style="margin-left: 10px">
          {{ $t('app.common.back') }}
        </el-button>
      </div>
      <p v-if="iccid" class="iccid-display">{{ $t('app.website.cardSearch.currentView') }} {{ iccid }}</p>
    </div>

    <div class="content-wrapper">
      <div class="left-panel">
        <div class="info-card">
          <h2 class="card-title">
            <span class="title-text">{{ $t('app.website.info.basicInfo') }}</span>
            <div class="title-actions">
              <el-button type="text" class="icon-button" :title="$t('app.website.info.refreshInfo')">
                <svg-icon icon-class="refresh" style="font-size: 20px" @click="refresh"/>
              </el-button>
              <el-button type="text" class="icon-button" :title="$t('app.website.info.contactSupport')">
                <svg-icon icon-class="kefu" style="font-size: 20px"/>
              </el-button>
            </div>
          </h2>
          <div class="info-grid">
            <div class="info-item">
              <span class="info-label">{{ $t('app.website.info.iccid') }}:</span>
              <span class="info-value">{{ cardData.iccid }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">{{ $t('app.website.info.msisdn') }}:</span>
              <span class="info-value">{{ cardData.msisdn || "-" }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">{{ $t('app.website.info.status') }}:</span>
              <span class="info-value">
								<el-tag v-if="cardData.showStatus" class="info-value" :type="getStatusClass(cardData.showStatus)">{{ getCardStatus(cardData.showStatus) }}</el-tag>
							</span>
            </div>
            <div class="info-item">
              <span class="info-label">{{ $t('app.website.info.expireTime') }}:</span>
              <span class="info-value">{{ cardData.expireTime || "-" }}</span>
            </div>

            <div class="info-item">
              <span class="info-label">{{ $t('app.website.info.totalFlow') }}:</span>
              <span class="info-value">{{ cardFlow.totalFlow || "0 MB" }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">{{ $t('app.website.info.usedFlow') }}:</span>
              <span class="info-value">{{ cardFlow.useFlow || "0 MB" }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">{{ $t('app.website.info.surplusFlow') }}:</span>
              <span class="info-value">{{cardFlow.surplusFlow || "0 MB"}}</span>
            </div>
          </div>
          <div class="chart" style="height: 200px"></div>
        </div>
      </div>
      <div class="right-panel">
        <div class="main-card">
          <h2 class="card-title">{{ $t('app.website.info.detailInfo') }}</h2>
          <div class="tabs-container">
            <el-tabs v-model="activeTab" @tab-click="handleTabClick" type="border-card" v-loading="loading">
              <el-tab-pane :label="$t('app.website.info.orderPackage')" name="flowProduct">
                <div class="tab-content">
                  <!-- 添加币种选择器 -->
                  <el-form label-width="160px" inline v-if="cardData && cardData.operationName == '国际'">
                    <el-form-item :label="$t('app.website.info.paymentCurrency')">
                      <el-select v-model="selectedCurrency" :placeholder="$t('app.website.info.selectCurrency')"
                                 @change="handleCurrencyChange"
                                 style="margin-bottom: 10px">
                        <el-option v-for="item in currencyList" :key="item.currency" :label="item.currency"
                                   :value="item.currency"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('app.website.info.useRegion')">
                      <el-select v-model="groupKey" :placeholder="$t('app.website.info.selectRegion')"
                                 @change="handleProductChange"
                                 style="margin-bottom: 10px">
                        <el-option v-for="item in cardGroupList" :key="item.groupKey"
                                   :label="language == 'zh' ? item.name : item.enShowName"
                                   :value="item.groupKey"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-form>
                  <div>
                    <div class="product-list">
                      <div v-for="product in productList" :key="product.productId" class="product-item" :class="{
                          selected:
                            selectedProduct &&
                            selectedProduct.productId === product.productId,
                        }" @click="handleProductSelect(product)">
                        <div class="product-header">
                          <div class="product-selection">
														<span class="product-name">{{
                              product.productName
                            }}</span>
                            <span class="selection-indicator" :class="{
                                selected:
                                  selectedProduct &&
                                  selectedProduct.productId ===
                                    product.productId,
                              }">
															<i class="el-icon-check"></i>
														</span>
                          </div>
                        </div>
                        <div class="product-details">
                          <div class="detail-item">
                            <span class="detail-label">Data</span>
                            <span class="detail-value">{{
                              formatFlow(product.showFlowCount)
                            }}</span>
                          </div>
                          <div class="detail-item">
                            <span class="detail-label">Validity</span>
                            <span class="detail-value">{{
                              formatValidity(product.validityTime)
                            }}</span>
                          </div>
                          <div class="detail-item">
                            <span class="detail-label">Price</span>
                            <span class="detail-value price">{{ product.currency }} {{ product.price }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="payment-section" v-if="selectedProduct">
                      <div class="selected-plan">
                        <div class="plan-info">
                          <h3 class="plan-title">
                            {{ selectedProduct.productName }}
                          </h3>
                          <div class="plan-price">
														<span>{{ selectedProduct.currency }}
															{{ selectedProduct.price }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="payment-container">

                        <div class="payment-methods" v-if="selectedCurrency != 'CNY'">
                          <div class="payment-options">
                            <div class="payment-option stripe" :class="{
                                selected: selectedPaymentMethod === '4',
                              }" @click="selectedPaymentMethod = '4'">
                              <span class="payment-icon">stripe</span>
                            </div>
                            <div class="payment-option paypal" :class="{
                                selected: selectedPaymentMethod === '3',
                              }" @click="selectedPaymentMethod = '3'">
                              <span class="payment-icon">PayPal</span>
                            </div>
                          </div>
                        </div>

                        <div class="payment-methods" v-if="selectedCurrency == 'CNY'">
                          <div class="payment-options">
                            <div class="payment-option stripe" :class="{
                                selected: selectedPaymentMethod === '1',
                              }" @click="selectedPaymentMethod = '1'">
                              <span class="payment-icon">{{ $t('app.website.info.wechat') }}</span>
                            </div>
                            <div class="payment-option paypal" :class="{
                                selected: selectedPaymentMethod === '2',
                              }" @click="selectedPaymentMethod = '2'">
                              <span class="payment-icon">{{ $t('app.website.info.alipay') }}</span>
                            </div>
                          </div>
                        </div>

                        <div class="purchase-action">
                          <el-button type="primary" class="purchase-button" @click="switchPay"
                                     :loading="purchasing">
                            {{ $t('app.website.info.purchase') }}
                          </el-button>
                        </div>
                      </div>
                    </div>
                    <!-- 未选择套餐提示 -->
                    <div class="no-selection" v-else>
                      <p>{{ $t('app.website.info.selectPackageTip') }}</p>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane :label="$t('app.website.info.flowPackageHistory')" name="cardProductHisoryList"
                           v-loading="loading">
                <div class="tab-content" style="overflow-y: auto; max-height: calc(100vh - 400px);">
                  <el-table :data="tabData.flowProduct" stripe style="width: 100%">
                    <el-table-column prop="orderNum" :label="$t('app.website.info.orderNumber')" min-width="180" align="center"></el-table-column>
                    <el-table-column prop="productName" :label="$t('app.website.info.packageName')" min-width="160" align="center"></el-table-column>
                    <el-table-column prop="startTime" :label="$t('app.website.info.startTime')" min-width="130" align="center"></el-table-column>
                    <el-table-column prop="endTime" :label="$t('app.website.info.endTime')" min-width="130" align="center"></el-table-column>
                    <el-table-column prop="useFlow" :label="$t('app.website.info.usedFlow')" min-width="120" align="center"></el-table-column>
                    <el-table-column prop="monthFlow" :label="$t('app.website.info.totalFlow')" min-width="110" align="center"></el-table-column>
                    <el-table-column prop="status" :label="$t('app.website.info.packageStatus')" min-width="100" align="center">
                      <template slot-scope="scope">
                        <el-tag v-if="scope.row.status === '1'" type="info">{{ $t('app.website.info.unused') }}</el-tag>
                        <el-tag v-else-if="scope.row.status === '2'" type="success">{{ $t('app.website.info.using') }}
                        </el-tag>
                        <el-tag v-else-if="scope.row.status === '3'" type="danger">{{ $t('app.website.info.used') }}
                        </el-tag>
                      </template>
                    </el-table-column>
                  </el-table>
                  
                </div>
              </el-tab-pane>
              <el-tab-pane :label="$t('app.website.info.smsPackageHistory')" name="cardSmsHisoryList"
                           v-loading="loading" v-if="cardData && cardData.smsShow == '1'">

                <div class="tab-content" style="overflow-y: auto; max-height: calc(100vh - 400px);">
                  <el-table :data="tabData.smsProduct" stripe style="width: 100%">
                    <el-table-column prop="orderNum" :label="$t('app.website.info.orderNumber')" min-width="180"
                                     align="center"></el-table-column>
                    <el-table-column prop="productName" :label="$t('app.website.info.packageName')" min-width="160"
                                     align="center"></el-table-column>
                    <el-table-column prop="startTime" :label="$t('app.website.info.startTime')" min-width="130"
                                     align="center"></el-table-column>
                    <el-table-column prop="endTime" :label="$t('app.website.info.endTime')" min-width="130"
                                     align="center"></el-table-column>
                    <el-table-column prop="moUse" :label="$t('app.website.info.usedSmsCount')" min-width="120"
                                     align="center"></el-table-column>
                    <el-table-column prop="moTotal" :label="$t('app.website.info.totalSmsCount')" min-width="110"
                                     align="center"></el-table-column>
                    <el-table-column prop="status" :label="$t('app.website.info.packageStatus')" min-width="100"
                                     align="center">
                      <template slot-scope="scope">
                        <el-tag v-if="scope.row.status === '1'" type="info">{{ $t('app.website.info.unused') }}</el-tag>
                        <el-tag v-else-if="scope.row.status === '2'" type="success">{{ $t('app.website.info.using') }}
                        </el-tag>
                        <el-tag v-else-if="scope.row.status === '3'" type="danger">{{ $t('app.website.info.used') }}
                        </el-tag>
                      </template>
                    </el-table-column>
                  </el-table>
                  
                </div>
              </el-tab-pane>
              <el-tab-pane :label="$t('app.website.info.voicePackageHistory')" name="cardVoiceHisoryList"
                           v-loading="loading" v-if="cardData && cardData.voiceShow == '1'">
                <div class="tab-content" style="overflow-y: auto; max-height: calc(100vh - 400px);">
                  <el-table :data="tabData.voiceProduct" stripe style="width: 100%">
                    <el-table-column prop="orderNum" :label="$t('app.website.info.orderNumber')" min-width="180"
                                     align="center"></el-table-column>
                    <el-table-column prop="productName" :label="$t('app.website.info.packageName')" min-width="160"
                                     align="center"></el-table-column>
                    <el-table-column prop="startTime" :label="$t('app.website.info.startTime')" min-width="130"
                                     align="center"></el-table-column>
                    <el-table-column prop="endTime" :label="$t('app.website.info.endTime')" min-width="130"
                                     align="center"></el-table-column>
                    <el-table-column prop="useSecond" :label="$t('app.website.info.usedVoiceSeconds')" min-width="120"
                                     align="center"></el-table-column>
                    <el-table-column prop="monthMinute" :label="$t('app.website.info.totalVoiceMinutes')"
                                     min-width="110" align="center"></el-table-column>
                    <el-table-column prop="status" :label="$t('app.website.info.packageStatus')" min-width="100"
                                     align="center">
                      <template slot-scope="scope">
                        <el-tag v-if="scope.row.status === '1'" type="info">{{ $t('app.website.info.unused') }}</el-tag>
                        <el-tag v-else-if="scope.row.status === '2'" type="success">{{ $t('app.website.info.using') }}
                        </el-tag>
                        <el-tag v-else-if="scope.row.status === '3'" type="danger">{{ $t('app.website.info.used') }}
                        </el-tag>
                      </template>
                    </el-table-column>
                  </el-table>
                  
                </div>
              </el-tab-pane>
              <el-tab-pane :label="$t('app.website.info.orderList')" name="orderList">
                <div class="tab-content" style="overflow-y: auto; max-height: calc(100vh - 400px);">
                  <el-table :data="tabData.orderList" stripe style="width: 100%" v-loading="loading">
                    <el-table-column prop="orderNum" :label="$t('app.website.info.orderNumber')" width="260"
                                     align="center"></el-table-column>
                    <el-table-column prop="payTime" :label="$t('app.website.info.orderTime')" width="180"
                                     align="center"></el-table-column>
                    <el-table-column prop="productName" :label="$t('app.website.info.productName')"
                                     align="center"></el-table-column>
                    <el-table-column prop="price" :label="$t('app.website.info.price')" width="140" align="center">
                      <template slot-scope="scope">
                        <span v-if="scope.row.money">{{ scope.row.currency }} {{ scope.row.money }}</span>
                        <span v-else>-</span>
                      </template>
                    </el-table-column>
                  </el-table>
                  
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="payTitle" :visible.sync="showQRCode" width="30%" class="qr-code-dialog">
      <div class="qr-code-container">
        <div class="payment-amount">
          {{ selectedCurrency }} {{ selectedProduct && selectedProduct.price }}
        </div>
        <vue-qr :text="payUrl" :size="256" :options="qrOptions"/>
        <div class="qr-code-tip">{{ payTitle }} {{ $t('app.website.info.scanQrCodePay') }}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
    import {
        siteCardInfo,
        siteCardFlow,
        siteCardProductHistory,
        siteCardSmsProductHistory,
        siteCardVoiceProductHistory,
        siteCardOrderHistory,
        siteCardGroupList,
        siteProductList,
        siteNormalProductList,
        siteCurrencyList,
        siteInternationalPay
    } from "@/api/website.js";

    import * as echarts from "echarts";
    import "echarts-liquidfill"; // 导入液体填充插件
    import VueQr from 'vue-qr';

    export default {
        name: "webCard",
        components: {
            VueQr
        },
        data() {
            return {
                language: localStorage.getItem("app_language") || "zh",
                iccid: "",
                searchIccid: "",
                cardData: {},
                cardFlow: {},
                currencyList: [],
                cardGroupList: [],
                activeTab: "flowProduct",
                loading: false,
                showResetModal: false,
                tabData: {
                    flowProduct: [], // 流量资费列表
                    smsProduct: [], // 短信资费列表
                    voiceProduct: [], // 语音资费列表
                    orderList: [], // 订单列表
                    cardProductHisoryList: [], // 操作列表
                },
                // 日期范围选择器
                dateRange: [],
                // 诊断结果
                diagnosticResult: null,
                // 图表实例
                chartInstance: null,
                // 添加支付币种选择
                selectedCurrency: "",
                groupKey: "", // 套餐分组key
                productList: [],
                selectedProduct: null,
                selectedPaymentMethod: "4",
                purchasing: false,
                showQRCode: false,
                payTitle: this.$t('app.website.info.alipay'),
                qrOptions: {
                    errorCorrectLevel: 'H', // 纠错级别
                    margin: 10 // 二维码边距
                },
                payUrl: ''
            };
        },
        created() {
			this.$i18n.locale = localStorage.getItem('app_language') || 'zh'
            // 从URL参数获取ICCID
            this.iccid = this.$route.query.iccid || "";
            this.searchIccid = this.iccid;
            this.loadCurrencyList();
            if (this.iccid) {
                this.loadCardData();
            }
        },
        watch: {
            // 监听路由参数变化，重新加载数据
            "$route.query.iccid": function (newIccid) {
                if (newIccid && newIccid !== this.iccid) {
                    this.iccid = newIccid;
                    this.loadCardData();
                }
            },
            selectedCurrency(newCurrency) {
                this.selectedPaymentMethod = newCurrency === "CNY" ? "1" : "4";
            }

        },
        mounted() {
            // 监听窗口大小变化
            window.addEventListener("resize", this.handleResize);
        },
        beforeDestroy() {
            // 销毁图表实例，释放资源
            if (this.chartInstance) {
                this.chartInstance.dispose();
                this.chartInstance = null;
            }
            // 移除事件监听器
            window.removeEventListener("resize", this.handleResize);
        },
        methods: {
            // 返回上一页
            handleBack() {
                this.$router.go(-1);
            },
            // 加载卡片详情数据
            loadCardData() {
                this.productList = [];
                this.tabData.flowProduct = [];
                this.tabData.smsProduct = [];
                this.tabData.voiceProduct = [];
                this.tabData.orderList = [];
                this.tabData.cardProductHisoryList = [];
                this.loading = true;
                let language = localStorage.getItem("app_language") || "zh";
                siteCardInfo({iccid: this.iccid, language})
                    .then((res) => {
                        try {
                            this.cardData = res.data.data;
                            if (this.cardData.operationName != '国际') {
                                this.selectedCurrency = 'CNY'
                                this.loadNormalProductList();
                            }else{
                              this.loadCardGroupList();
                            }
                            if (this.cardData.smsShow == '1') {
                                this.loadSmsProductList();
                            }
                            if (this.cardData.voiceShow == '1') {
                                this.loadVoiceProductList();
                            }
							// 更新URL参数，便于分享和刷新
							this.$router.replace({
								query: {...this.$route.query, iccid: this.iccid},
							});
							this.loadCardFlow();
							this.loadFlowProductList();
							this.loadOrderList();
                        } catch (error) {
                            console.error("加载卡片详情失败:", error);
                            this.$message.error(
                                error.message || this.$t('app.website.info.loadCardDetailFail')
                            );
                        }
                    })
                    .catch((error) => {
						this.iccid = null;
                        // this.$message.error(this.$t('app.website.info.loadCardDataFail'));
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            // 加载卡片流量数据
            loadCardFlow() {
                let language = localStorage.getItem("app_language") || "zh";
                siteCardFlow({iccid: this.iccid, language})
                    .then((res) => {
                        try {
                            this.cardFlow = res.data.data;
                        } catch (error) {
                            console.error("加载卡片流量数据失败:", error);
                            this.$message.error(
                                error.message || this.$t('app.website.info.loadCardFlowFail')
                            );
                        }
                    })
                    .catch((error) => {
                        this.$message.error(this.$t('app.website.info.loadCardFlowFail'));
                        console.error("Load card flow data error:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                        // 数据加载完成后更新图表
                        this.$nextTick(() => {
                            this.initFlowChart();
                        });
                    });
            },
            loadCardGroupList() {
                this.productList = [];
                this.selectedProduct = null;
                siteCardGroupList({iccid: this.iccid})
                    .then((res) => {
                        try {
                            this.cardGroupList = res.data.data;
                            if (this.cardGroupList.length > 0) {
                                this.groupKey = this.cardGroupList[0].groupKey;
                                this.loadProductList();
                            }
                        } catch (error) {
                            console.error("加载卡组列表失败:", error);
                            this.$message.error(
                                error.message || this.$t('app.website.info.loadCardGroupFail')
                            );
                        }
                    })
                    .catch((error) => {
                        this.$message.error(this.$t('app.website.info.loadCardGroupFail'));
                        console.error("Load card group list error:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            loadCurrencyList() {
                siteCurrencyList()
                    .then((res) => {
                        this.currencyList = res.data.data;
                    })
            },

            // 处理标签页切换
            handleTabClick(tab) {
              if(!this.iccid){
                return;
              }
              // 根据选中的标签页加载对应的内容
              this.loadTabContent(tab.name);
            },

            // 加载标签页内容
            loadTabContent(tabName) {
                this.loading = true;

                // 根据不同的标签页加载对应的数据
                switch (tabName) {
                    case "flowProduct":
                        if (this.cardData.operationName == '国际') {
                            this.loadProductList();
                        } else {
                            this.loadNormalProductList();
                        }
                        
                        break;
                    case "orderList":
                        this.loadOrderList();
                        break;
                    case "cardProductHisoryList":
                        this.loadFlowProductList();
                        break;
                    default:
                        setTimeout(() => {
                            this.loading = false;
                        }, 300);
                }
            },

            // 加载流量资费列表
            loadFlowProductList() {
                siteCardProductHistory({iccid: this.iccid})
                    .then((res) => {
                        try {
                            this.tabData.flowProduct = res.data.data;
                        } catch (error) {
                            console.error("加载流量资费列表失败:", error);
                            this.$message.error(
                                error.message || this.$t('app.website.info.loadFlowProductFail')
                            );
                        }
                    })
                    .catch((error) => {
                        this.$message.error(this.$t('app.website.info.loadFlowProductFail'));
                        console.error("Load flow product list error:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            loadSmsProductList() {
                siteCardSmsProductHistory({iccid: this.iccid})
                    .then((res) => {
                        try {
                            this.tabData.smsProduct = res.data.data;
                        } catch (error) {
                            console.error("加载短信套餐列表失败:", error);
                            this.$message.error(
                                error.message || this.$t('app.website.info.loadSmsProductFail')
                            );
                        }
                    })
                    .catch((error) => {
                        this.$message.error(this.$t('app.website.info.loadSmsProductFail'));
                        console.error("Load sms product list error:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });

            },
            loadVoiceProductList() {
                siteCardVoiceProductHistory({iccid: this.iccid})
                    .then((res) => {
                        try {
                            this.tabData.voiceProduct = res.data.data;
                        } catch (error) {
                            console.error("加载语音套餐列表失败:", error);
                            this.$message.error(
                                error.message || this.$t('app.website.info.loadVoiceProductFail')
                            );
                        }
                    })
                    .catch((error) => {
                        this.$message.error(this.$t('app.website.info.loadVoiceProductFail'));
                        console.error("Load voice product list error:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });

            },
            // 加载订单列表
            loadOrderList() {
                siteCardOrderHistory({iccid: this.iccid})
                    .then((res) => {
                        try {
                            this.tabData.orderList = res.data.data;
                        } catch (error) {
                            console.error("加载订单列表失败:", error);
                            this.$message.error(
                                error.message || this.$t('app.website.info.loadOrderListFail')
                            );
                        }
                    })
                    .catch((error) => {
                        this.$message.error(this.$t('app.website.info.loadOrderListFail'));
                        console.error("Load order list error:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            //套餐列表
            loadProductList() {
                if(!this.groupKey){
                  this.loading = false;
                  return;
                }
                this.productList = [];
                this.selectedProduct = null;
                siteProductList({
                    iccid: this.iccid,
                    groupKey: this.groupKey,
                    currency: this.selectedCurrency,
                })
                    .then((res) => {
                        try {
                            this.selectedCurrency = res.data.data.currency || "";
                            this.productList = res.data.data.list;
                            if (this.productList.length > 0) {
                                this.selectedProduct = this.productList[0];
                            }

                        } catch (error) {
                            console.error("加载套餐列表失败:", error);
                            this.$message.error(
                                error.message || this.$t('app.website.info.loadPackageListFail')
                            );
                        }
                    })
                    .catch((error) => {
                        this.$message.error(this.$t('app.website.info.loadPackageListFail'));
                        console.error("Load product list error:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            //渲染普通套餐  默认第一个
            loadNormalProductList() {
                this.productList = [];
                siteNormalProductList({iccid: this.iccid})
                    .then((res) => {
                        try {
                            this.productList = res.data.data;
                            if (this.productList.length > 0) {
                                this.selectedProduct = this.productList[0];
                            }
                        } catch (error) {
                            this.$message.error(
                                error.message || this.$t('app.website.info.loadNormalPackageListFail')
                            );
                        }
                    })
                    .catch((error) => {
                        this.$message.error(this.$t('app.website.info.loadNormalPackageListFail'));
                        console.error("Load normal product list error:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            handleCurrencyChange() {
                this.loadProductList();
            },
            handleProductChange() {
                this.selectedProduct = null;
                this.loadProductList();
            },
            // 处理日期范围变化
            handleDateRangeChange(val) {
                this.dateRange = val;
                // 如果是日流量或月流量标签页，重新加载数据
                if (["dayFlow", "monthFlow"].includes(this.activeTab)) {
                    this.loadTabContent(this.activeTab);
                }
            },

            // 获取状态对应的样式类
            getStatusClass(status) {
                switch (status) {
                    case "1":
                        return "info";
                    case "2":
                        return "info";
                    case "3":
                        return "info";
                    case "4":
                        return "success";
                    case "5":
                        return "danger";
                    case "6":
                        return "warning";
                    case "7":
                        return "warning";
                    default:
                        return "info";
                }
            },
            getCardStatus(status) {
                switch (status) {
                    case "1":
                        return this.$t('app.website.info.inStock');
                    case "2":
                        return this.$t('app.website.info.toActivate');
                    case "3":
                        return this.$t('app.website.info.testable');
                    case "4":
                        return this.$t('app.website.info.activated');
                    case "5":
                        return this.$t('app.website.info.stopped');
                    case "6":
                        return this.$t('app.website.info.preClosed');
                    case "7":
                        return this.$t('app.website.info.closed');
                    default:
                        return this.$t('app.website.info.none');
                }
            },
            // 立即刷新
            refresh() {
                this.$message.success(this.$t('app.website.info.refreshSuccess'));
            },
            // 计算流量百分比（用于图表显示）
            calculateFlowPercentage(flowStr) {
                // 提取数字部分
                const flow = parseFloat(flowStr);
                // 假设最大流量为10GB，计算百分比
                return Math.min(100, (flow / 10) * 100);
            },

            // 格式化流量显示
            formatFlow(flowInMB) {
                if (flowInMB >= 1024) {
                    return `${(flowInMB / 1024).toFixed(2)} GB`;
                }
                return `${flowInMB} MB`;
            },

            // 格式化有效期显示
            formatValidity(days) {
                return `${days} day${days > 1 ? "s" : ""}`;
            },


            // 处理产品选择
            handleProductSelect(product) {
                this.selectedProduct = product;
            },
            switchPay() {
                if (this.cardData.operationName == '国际') {
                    this.internationalPay();
                } else {
                    this.normalPay();
                }
            },
            // 国际卡支付
            internationalPay() {
                if (!this.selectedProduct) {
                    this.$message.warning(this.$t('app.website.info.selectPackageFirst'));
                    return;
                }
                this.purchasing = true;
                let product = {
                    productId: this.selectedProduct.productId,
                    groupKey: this.groupKey,
                    payType: this.selectedPaymentMethod,
                    currency: this.selectedCurrency,
                    iccid: this.iccid,
                    price: this.selectedProduct.price,
                    language: this.language,
					          host: window.location.host
                };
                siteInternationalPay(product).then((res) => {
                    if (this.selectedPaymentMethod === '1') {
                        this.showQRCode = true;
                        this.payTitle = this.$t('app.website.info.wechat')
                        this.orderNum = res.data.data.orderNum
                        this.payUrl = res.data.data.returnUrl

                    }
                    if (this.selectedPaymentMethod === '2') {
                        this.showQRCode = true;
                        this.payTitle = this.$t('app.website.info.alipay')
                        this.orderNum = res.data.data.orderNum
                        this.payUrl = res.data.data.returnUrl

                    }
                    if (this.selectedPaymentMethod === '3') {
                        window.open(res.data.data.return_url, '_blank');
                    }
                    if (this.selectedPaymentMethod === '4') {
                        window.open(res.data.data.return_url, '_blank');
                    }

                    this.purchasing = false;
                }).catch(() => {
                    this.$message.error(this.$t('app.website.info.paymentFail'));
                    this.purchasing = false;
                });

            },
            //国内卡支付
            normalPay() {

            },

            // 处理搜索
            handleSearch() {
                if (!this.searchIccid.trim()) {
                    this.$message.warning(this.$t('app.website.info.enterIccid'));
                    return;
                }

                // 验证ICCID格式（可以根据实际需求调整验证规则）
                if (!/^[A-Za-z0-9]{18,22}$/.test(this.searchIccid.trim())) {
                    this.$message.error(this.$t('app.website.info.enterValidIccid'));
                    return;
                }

                this.iccid = this.searchIccid.trim();
                this.loadCardData();
                
            },

            // 初始化流量使用情况图表
            initFlowChart() {
                // 获取图表DOM元素
                const chartDom = this.$el.querySelector(".chart");
                if (!chartDom) return;

                // 初始化图表实例
                if (!this.chartInstance) {
                    this.chartInstance = echarts.init(chartDom);
                }
                let percent = this.cardFlow.percent;
                // 使用蓝色波浪，与图片颜色一致
                const color = ["#1890ff", "#bae7ff"]; // 蓝色及浅蓝色
                const option = {
                    backgroundColor: "transparent",
                    series: [{
                        type: "liquidFill",
                        shape: "circle",
						itemStyle: {
							borderColor: "#40a9ff",
                        },
                        center: ["50%", "50%"],
                        data: [percent, percent, percent],
                        // 调整半径，确保图表内容不会被容器遮挡
                        radius: "90%",
                        // 设置内部边距
                        padding: [30, 30, 30, 30],
                        waveAnimation: true,
                        waveLength: "150%",
                        waveDirection: "right",
                        waveAnimationDuration: 3000,
                        // 设置背景样式，包括边框
                        backgroundStyle: {
                            borderWidth: 1,
                            borderColor: "#e6e6e6",
                            color: "transparent",
                        },
                    },],
                };
                // 应用图表配置
                this.chartInstance.setOption(option);
            },

            // 监听窗口大小变化，调整图表
            handleResize() {
                if (this.chartInstance) {
                    this.chartInstance.resize();
                }
            },
        },
    };
</script>

<style scoped less>
  .web-card-info {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: 100vh;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  }

  /* 页面头部样式 */
  .page-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 15px 40px;
    border-radius: 12px;
    margin-bottom: 15px;
    box-shadow: 0 8px 32px rgba(102, 126, 234, 0.3);
    position: relative;
    overflow: hidden;
  }

  .page-header::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    z-index: 1;
  }

  .page-header h1 {
    margin: 0 0 13px 0;
    font-size: 25px;
    font-weight: 600;
    position: relative;
    z-index: 2;
  }

  .search-container {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    position: relative;
    z-index: 2;
  }

  .iccid-display {
    margin: 0;
    font-size: 16px;
    opacity: 0.9;
    font-family: "Courier New", monospace;
    position: relative;
    z-index: 2;
  }

  /* 内容容器样式 */
  .content-wrapper {
    display: flex;
    gap: 30px;
    align-items: flex-start;
  }

  /* 左侧面板样式 */
  .left-panel {
    width: 350px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    height: calc(100vh - 220px);
  }

  /* 右侧面板样式 */
  .right-panel {
    height: calc(100vh - 220px);
    flex: 1;
    min-width: 0;
    /* 确保flex子元素不会溢出 */
  }

  /* 卡片通用样式 */
  .info-card,
  .action-card,
  .main-card {
    height: 100%;
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    overflow: hidden;
  }

  .info-card:hover,
  .action-card:hover,
  .main-card:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    transform: translateY(-2px);
  }

  /* 卡片标题样式 */
  .card-title {
    font-size: 18px;
    font-weight: 600;
    color: #303133;
    margin: 0;
    padding: 20px 24px 15px;
    border-bottom: 1px solid #f0f2f5;
  }

  /* 信息网格样式 */
  .info-grid {
    padding: 20px 24px;
  }

  .info-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #f5f7fa;
  }

  .info-item:last-child {
    border-bottom: none;
  }

  .info-label {
    color: #606266;
    font-weight: 500;
    font-size: 14px;
    min-width: 90px;
  }

  .info-value {
    color: #303133;
    font-weight: 600;
    font-size: 14px;
    text-align: right;
    word-break: break-all;
    flex: 1;
    margin-left: 15px;
  }

  /* 状态标签样式 */
  .status-tag {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 16px;
    font-size: 12px;
    font-weight: 500;
  }

  .status-active {
    background-color: #f0f9ff;
    color: #409eff;
  }

  .status-stopped {
    background-color: #fdf6ec;
    color: #e6a23c;
  }

  .status-pre-delete {
    background-color: #fef0f0;
    color: #f56c6c;
  }

  .status-deleted {
    background-color: #f5f7fa;
    color: #909399;
  }

  .status-normal {
    background-color: #f0f2f5;
    color: #606266;
  }

  /* 图标按钮样式 */
  .icon-button {
    padding: 0;
    margin-left: 8px;
    color: #606266;
    transition: color 0.3s;
  }

  .icon-button:hover {
    color: #409eff;
  }

  .card-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .title-text {
    flex-shrink: 0;
  }

  .title-actions {
    display: flex;
    align-items: center;
    gap: 30px;
  }

  .icon-button {
    padding: 0;
    color: #606266;
    transition: color 0.3s;
  }

  .icon-button:hover {
    color: #409eff;
  }

  /* 表单输入框样式 */
  .el-input__inner {
    border-radius: 4px;
    transition: border-color 0.3s ease;
  }

  .el-input__inner:focus {
    border-color: #667eea;
    box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
  }

  /* 表格样式优化 */
  .el-table {
    border-radius: 8px;
    overflow: hidden;
  }

  .el-table th {
    background-color: #f5f7fa;
    font-weight: 600;
  }

  .el-table tr:hover > td {
    background-color: #f5f7fa;
  }

  /* 滚动条样式 */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  /* 标签页容器样式 */
  .tabs-container {
    padding: 20px;
  }

  .tabs-container .el-tabs__header {
    margin-bottom: 20px;
  }

  /* 标签页内容样式 */
  .tab-content {
    padding: 30px 20px;
    min-height: 400px;
    background-color: #fafafa;
    border-radius: 8px;
    position: relative;
  }

  .placeholder-text {
    color: #909399;
    font-size: 16px;
    margin: 0;
    line-height: 1.8;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .no-data-text {
    text-align: center;
    color: #909399;
    padding: 40px 0;
    font-size: 14px;
  }

  /* 产品列表样式 */
  .product-list {
    display: flex;
    flex-wrap: nowrap;
    gap: 16px;
    margin-top: 16px;
    overflow-x: auto;
    white-space: nowrap;
    padding-bottom: 20px;
    /* 增加底部padding为滚动条预留足够空间 */
    scrollbar-gutter: stable;
    /* 为滚动条预留固定空间，防止宽度变化 */
    min-height: 200px;
    /* 设置最小高度，确保布局稳定 */
  }

  /* 滚动条样式优化 */
  .product-list::-webkit-scrollbar {
    height: 6px;
  }

  .product-list::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  .product-list::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }

  .product-list::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  /* 为不支持scrollbar-gutter的浏览器添加兼容性样式 */
  @supports not (scrollbar-gutter: stable) {
    .product-list {
      /* 固定宽度容器，确保卡片尺寸一致 */
      width: 100%;
    }
  }

  /* 产品卡片样式 */
  .product-item {
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    padding: 20px;
    width: 280px;
    cursor: pointer;
    transition: all 0.3s ease;
    background-color: #fff;
    position: relative;
    flex-shrink: 0;
    /* 防止卡片被压缩 */
  }

  .product-item:hover {
    border-color: #dcdfe6;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  /* 选中状态样式 */
  .product-item.selected {
    border-color: #67c23a;
    box-shadow: 0 2px 12px 0 rgba(103, 194, 58, 0.2);
  }

  /* 产品头部样式 */
  .product-header {
    margin-bottom: 16px;
  }

  .product-selection {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .product-name {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
  }

  /* 选择指示器样式 */
  .selection-indicator {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid #dcdfe6;
    display: flex;
    align-items: center;
    justify-content: center;
    color: transparent;
    transition: all 0.3s ease;
  }

  .selection-indicator.selected {
    background-color: #67c23a;
    border-color: #67c23a;
    color: #fff;
  }

  /* 产品详情样式 */
  .product-details {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .detail-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .detail-label {
    font-size: 14px;
    color: #606266;
  }

  .detail-value {
    font-size: 14px;
    font-weight: 500;
    color: #303133;
  }

  /* 价格特殊样式 */
  .detail-value.price {
    color: #e66a3c;
    font-weight: 600;
    font-size: 16px;
  }

  /* 支付区域样式 */
  .payment-section {
    margin-top: 30px;
    padding: 20px;
    background-color: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e9ecef;
  }

  /* 选中套餐显示样式 */
  .selected-plan {
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #dee2e6;
  }

  .plan-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .plan-title {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #303133;
  }

  .plan-price {
    font-size: 20px;
    font-weight: 700;
    color: #e66a3c;
  }

  .payment-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  /* 支付方式样式 */
  .payment-methods {
    flex: 1;
    margin-bottom: 0;
  }

  .payment-title {
    margin: 0 0 15px 0;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
  }

  .payment-options {
    display: flex;
    gap: 15px;
  }

  .payment-option {
    width: 180px;
    padding: 12px 10px;
    border: 2px solid #e4e7ed;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-align: center;
    font-weight: 500;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  .payment-option:hover {
    border-color: #dcdfe6;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .payment-option.selected {
    border-color: #409eff;
    background-color: #ecf5ff;
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
  }

  .payment-option.paypal {
    border-color: #c9daf8;
  }

  .payment-option.paypal.selected {
    background-color: #e8f0fe;
    border-color: #0070ba;
  }

  .payment-option.stripe {
    border-color: #c9e2f8;
  }

  .payment-option.stripe.selected {
    background-color: #e8f0fe;
    border-color: #008cdd;
  }

  .payment-icon {
    font-weight: bold;
    font-size: 16px;
    display: inline-block;
  }

  .payment-option.paypal .payment-icon {
    color: #0070ba;
  }

  .payment-option.stripe .payment-icon {
    color: #008cdd;
  }

  /* 购买按钮样式 */
  .purchase-action {
    display: flex;
    justify-content: flex-end;
  }

  .purchase-button {
    background-color: #28a745;
    border-color: #28a745;
    padding: 12px 30px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 4px;
    transition: all 0.3s ease;
  }

  .purchase-button:hover {
    background-color: #218838;
    border-color: #1e7e34;
  }

  /* 未选择套餐提示样式 */
  .no-selection {
    margin-top: 30px;
    padding: 40px;
    text-align: center;
    color: #909399;
    background-color: #f8f9fa;
    border-radius: 8px;
  }

  /* 日期筛选器样式 */
  .date-filter {
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .mt-20 {
    margin-top: 20px;
  }

  /* 流量图表样式 */
  .flow-chart-mini {
    height: 20px;
    background-color: #e6f7ff;
    border-radius: 10px;
    overflow: hidden;
  }

  .flow-bar {
    height: 100%;
    background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
    border-radius: 10px;
    transition: width 0.5s ease;
  }

  /* 状态样式 */
  .status-success {
    color: #67c23a;
  }

  .status-processing {
    color: #e6a23c;
  }

  .status-fail,
  .status-error {
    color: #f56c6c;
  }

  .status-warning {
    color: #e6a23c;
  }

  /* 诊断结果样式 */
  .diagnostic-result {
    padding: 10px 0;
  }

  .diagnostic-result h3 {
    margin: 0 0 10px 0;
    font-size: 16px;
    color: #303133;
  }

  .diagnostic-result .summary {
    margin: 0 0 15px 0;
    font-size: 14px;
    color: #606266;
  }

  .diagnostic-items {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .diagnostic-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
  }

  .item-name {
    color: #606266;
    min-width: 100px;
  }

  .item-status {
    font-weight: 600;
  }

  .status-ok {
    color: #67c23a;
  }

  .status-warning {
    color: #e6a23c;
  }

  .item-desc {
    color: #909399;
    flex: 1;
  }

  .qr-code-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 10px;
  }

  .payment-amount {
    font-size: 24px;
    margin-bottom: 20px;
    font-weight: bold;
    color: #e66a3c;
  }

  /* 响应式设计 */
  @media (max-width: 1200px) {
    .content-wrapper {
      flex-direction: column;
    }

    .left-panel {
      width: 100%;
      flex-direction: row;
      flex-wrap: wrap;
    }

    .right-panel {
      width: 100%;
    }

    .info-card,
    .action-card {
      flex: 1;
      min-width: 300px;
    }

    .payment-container {
      flex-direction: column;
      align-items: stretch;
    }
  }

  @media (max-width: 768px) {
    .web-card-info {
      padding: 15px;
    }

    .page-header {
      padding: 15px 25px;
      margin-bottom: 15px;
    }

    .page-header h1 {
      font-size: 24px;
      margin-bottom: 10px;
    }

    .iccid-display {
      font-size: 16px;
    }

    .left-panel {
      flex-direction: column;
    }

    .info-card,
    .action-card {
      min-width: auto;
    }

    .action-buttons {
      grid-template-columns: 1fr;
      gap: 10px;
    }

    .info-grid {
      padding: 15px 20px;
    }

    .card-title {
      padding: 15px 20px 10px;
      font-size: 16px;
    }

    .tabs-container {
      padding: 15px;
    }

    .tab-content {
      padding: 20px 15px;
      min-height: 200px;
    }

    .payment-container {
      flex-direction: column;
      align-items: stretch;
    }
  }

  @media (max-width: 480px) {
    .web-card-info {
      padding: 10px;
    }

    .info-item {
      flex-direction: column;
      align-items: flex-start;
      padding: 10px 0;
    }

    .info-value {
      margin-left: 0;
      margin-top: 5px;
      text-align: left;
    }

    .payment-container {
      flex-direction: column;
      align-items: stretch;
    }
  }
</style>
